import React, { useState, useEffect, useCallback } from 'react';
import Back1 from '../Images/back.jpg';
import Back2 from '../Images/JCPIC/back2.jpg';
import { IoArrowUpCircleOutline } from "react-icons/io5";
import ClubOfficeInfo from './OfficeInfo';
import Tabs from './Management';

export default function About() {
    const [activeSlide, setActiveSlide] = useState(0);
    const slides = [Back2, Back1];

    const changeSlides = useCallback(() => {
        setActiveSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, [slides.length]);  // ✅ Dependency fixed

    useEffect(() => {
        const id = setInterval(changeSlides, 4000);
        return () => clearInterval(id);
    }, [changeSlides]);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div>
            <div className="slider-container">
                {slides.map((slide, index) => (
                    <div
                        key={index}
                        className={`slides ${index === activeSlide ? 'active' : ''}`}
                        style={{ backgroundImage: `url(${slide})`, width: "100%", backgroundPosition: "center", backgroundSize: "cover" }}
                    ></div>
                ))}
                <div className="controls-container">
                    {slides.map((_, index) => (
                        <div
                            key={index}
                            className={`control ${index === activeSlide ? 'active' : ''}`}
                            onClick={() => setActiveSlide(index)}
                        ></div>
                    ))}
                </div>
            </div>
            <div className='container'>
                <p className='text-center p-4' style={{ fontSize: "2em", fontWeight: 600, color: "#DC143C", fontFamily: '"Playwrite FR Moderne", cursive' }}>About Jai Club</p>
                <div className='row'>
                    <div className='col-lg-12'>
                        <p className='text-center' style={{ fontSize: "1em", fontWeight: 400, color: "#000", }}>Set in 7 acres of land, Jai Club is a famous social club in Jaipur in Rajasthan. Founded in 1947, it has facilities for recreation / sports, dining and lodging. The gymnasium has facilities well suited for body fitness. Indoor and outdoor games such as badminton, billiards, cards, tennis and cricket can be played. There is a children's pool and a swimming pool with adjoining dressing rooms.</p>
                    </div>
                </div>
                <div className='my-2'>
                    <ClubOfficeInfo />
                </div>
                <div className='container'>
                    <div className="row mt-2">
                        <div className="text-center" style={{ fontSize: "2em", fontWeight: 600, color: "#DC143C" }}>
                            Management Committee
                        </div>
                    </div>
                    <Tabs />
                </div>
            </div>
            <div className="scroll-to-top-button rounded-2" onClick={scrollToTop} style={{ width: 40, height: 40, backgroundColor: "#ff68f0", color: "#fff", alignItems: "center", justifyContent: "center", display: "flex" }}>
                <IoArrowUpCircleOutline style={{ fontSize: 30 }} />
            </div>
        </div>
    );
}
